import { v4 as uuid } from 'uuid'

import api from '@/api'

import { Level, Levels, Distribution } from './constants'
export default {
  namespaced: true,
  state: {
    organicTypes: [],
    types: [],
    volatilization: Level.UNKNOWN,
    fertigation: false,
    organicApplications: [
      {
        id: uuid(),
        fertilizer: 1,
        date: new Date(),
        rate: 0
      }
    ],
    applications: []
  },
  mutations: {
    setVolatilization (state, volatilization) {
      if (!Levels.includes(volatilization)) {
        throw new Error(`Invalid volatilization value ${volatilization}`)
      }
      state.volatilization = volatilization
    },
    setFertigation (state, fertigation) {
      if (![true, false].includes(fertigation)) {
        throw new Error(`Invalid fertigation value ${fertigation}`)
      }
      state.fertigation = fertigation
      if (state.applications.length > 0 && fertigation) {
        for (const application of state.applications) {
          application.distribution = Distribution.ONE_TIME
        }
      }
    },
    setOrganicTypes (state, types) {
      if (!Array.isArray(types)) {
        throw new Error('Invalid organic fertilizer list')
      }
      state.organicTypes = types
    },
    setTypes (state, types) {
      if (!Array.isArray(types)) {
        throw new Error('Invalid fertilizer list')
      }
      state.types = types
    },
    addOrganicApplication (state, { fertilizer, rate, date }) {
      const id = uuid()
      const found = state.organicTypes.find((current) => current.name === fertilizer)
      if (!found) {
        throw new Error(`Invalid organic fertilizer ${fertilizer}`)
      }
      const newApplication = {
        id,
        fertilizer: found.id,
        rate,
        date
      }
      state.organicApplications.push(newApplication)
    },
    updateOrganicApplication (state, { index, fertilizer, rate, date }) {
      const application = state.organicApplications[index]
      if (fertilizer) {
        application.fertilizer = fertilizer
      }
      if (rate) {
        application.rate = rate
      }
      if (date) {
        application.date = date
      }
      state.organicApplications.splice(index, 1, application)
    },
    removeOrganicApplication (state, index) {
      state.organicApplications.splice(index, 1)
    },
    addApplication (state, { fertilizer, distribution, rate, date, fromDate, toDate, every }) {
      const id = uuid()
      const found = state.types.find((current) => current.id === fertilizer)
      if (!found) {
        throw new Error(`Invalid fertilizer ${fertilizer}`)
      }
      const newApplication = {
        id,
        fertilizer: found.id,
        distribution,
        rate,
        date,
        fromDate,
        toDate,
        every
      }
      state.applications.push(newApplication)
    },
    updateApplication (state, { index, fertilizer, distribution, rate, date, fromDate, toDate, every }) {
      const application = state.applications[index]
      if (fertilizer) {
        const found = state.types.find((current) => current.id === fertilizer)
        if (!found) {
          throw new Error(`Invalid fertilizer ${fertilizer}`)
        }
        application.fertilizer = found.id
      }

      if (rate) {
        application.rate = rate
      }

      // If we change distribution, then we change
      // application.distribution.
      if (distribution) {
        application.distribution = distribution
      } else {
        distribution = application.distribution
      }

      // This is used only if it is a one-time thing.
      if (date && distribution === Distribution.ONE_TIME) {
        application.date = date
      }

      // This is used only if it is a periodical thing.
      if (fromDate && distribution === Distribution.PERIODICAL) {
        application.fromDate = fromDate
      }
      if (toDate && distribution === Distribution.PERIODICAL) {
        application.toDate = toDate
      }
      if (every && distribution === Distribution.PERIODICAL) {
        application.every = every
      }

      state.applications.splice(index, 1, application)
    },
    removeApplication (state, index) {
      const [removed] = state.applications.splice(index, 1)
      console.log('Removed: ' + removed)
    }
  },
  actions: {
    async loadOrganicTypes ({ commit }) {
      const types = await api.loadOrganicFertilizers()
      commit('setOrganicTypes', types)
    },
    async loadTypes ({ commit }) {
      const types = await api.loadIrrigationMethods()
      commit('setTypes', types)
    }
  }
}
